/* 
Quick Tip 

- Use the below function in the EmojiGame Component to shuffle the emojisList every time when an emoji is clicked.

const shuffledEmojisList = () => {
  const {emojisList} = this.props
  return emojisList.sort(() => Math.random() - 0.5)
}

*/

// Write your code here.

import {Component} from 'react'

import NavBar from '../NavBar'

import EmojiCard from '../EmojiCard'

import WinOrLoseCard from '../WinOrLoseCard'

import './index.css'

class EmojiGame extends Component {
  state = {
    clickedEmojisList: [],
    score: 0,
    topScore: 0,
    showScoreCardInNavBar: true,
    showEmojiContainer: true,
    won: false,
    lost: false,
    isWon: false,
  }

  onClickEmoji = id => {
    const {emojisList} = this.props
    const {clickedEmojisList, topScore} = this.state

    if (clickedEmojisList.includes(id)) {
      // Game Over
      const newTopScore = Math.max(clickedEmojisList.length, topScore)
      this.setState({
        topScore: newTopScore,
        clickedEmojisList: [],
        showScoreCardInNavBar: false,
        showEmojiContainer: false,
        lost: true,
      })
    } else {
      const newClickedList = [...clickedEmojisList, id]
      if (newClickedList.length === emojisList.length) {
        // Game Won
        this.setState({
          clickedEmojisList: [],
          score: emojisList.length,
          topScore: emojisList.length,
          showScoreCardInNavBar: false,
          showEmojiContainer: false,
          won: true,
          isWon: true,
        })
      } else {
        this.setState({
          clickedEmojisList: newClickedList,
          score: newClickedList.length,
        })
      }
    }
  }

  onClickPlayAgain = () => {
    this.setState({
      clickedEmojisList: [],
      score: 0,
      showScoreCardInNavBar: true,
      showEmojiContainer: true,
      won: false,
      lost: false,
    })
  }

  render() {
    const {emojisList} = this.props

    const {
      score,
      topScore,
      showScoreCardInNavBar,
      showEmojiContainer,
      won,
      lost,
      isWon,
    } = this.state

    const shuffledEmojisList = emojisList.sort(() => Math.random() - 0.5)

    return (
      <div className="main-container">
        <NavBar
          score={score}
          topScore={topScore}
          showScoreCard={showScoreCardInNavBar}
        />
        {showEmojiContainer && (
          <ul className="emoji-container">
            {shuffledEmojisList.map(each => (
              <EmojiCard
                details={each}
                key={each.id}
                onClickEmoji={this.onClickEmoji}
              />
            ))}
          </ul>
        )}
        {won && (
          <WinOrLoseCard
            isWon={isWon}
            onClickPlayAgain={this.onClickPlayAgain}
            score={score}
          />
        )}
        {lost && (
          <WinOrLoseCard
            isWon={isWon}
            onClickPlayAgain={this.onClickPlayAgain}
            score={score}
          />
        )}
      </div>
    )
  }
}

export default EmojiGame
